// Канал и метки перехода по ссылке магазина или партнёра (PDF «Доработки
// платформы», п.2; 27.10.2026). QR из генератора кабинета продавца ведёт на
// web.osmix.ru/s/<код>?utm_source=qr_generator&utm_medium=social&utm_campaign=<код>
// - такой переход шлюз засчитывает как «QR», остальные - как «ссылка».
import type { ReferralVisitMeta } from "@/api/types";

const UTM_KEYS = ["source", "medium", "campaign", "content", "term"] as const;

export const referralMetaOf = (search: string): ReferralVisitMeta => {
	const params = new URLSearchParams(search);
	const utm: NonNullable<ReferralVisitMeta["utm"]> = {};
	for (const key of UTM_KEYS) {
		const value = params.get(`utm_${key}`)?.trim();
		if (value) utm[key] = value.slice(0, 200);
	}
	const channel = utm.source?.toLowerCase() === "qr_generator" ? "qr" : "link";
	return Object.keys(utm).length > 0 ? { channel, utm } : { channel };
};
